<template>
  <div class="history-and-more-details">
    <div v-show="showTabbable">
      <ul
        class="nav nav-tabs nav-fill"
        id="history-and-more-details-nav"
        role="tablist"
      >
        <li class="nav-item">
          <a
            class="nav-link active font-weight-bold"
            href="#BHistory"
            role="tab"
            >Booking History</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link font-weight-bold" href="#BinCollection" role="tab"
            >Bin Collection Schedules</a
          >
        </li>
      </ul>
      <div
        class="tab-content border-left border-bottom border-right"
        id="myTabContent"
      >
        <div
          class="tab-pane fade show active"
          id="BHistory"
          role="tabpanel"
          aria-labelledby="BHistory-tab"
        >
          <history-details v-if="showTabbable" />
        </div>
        <div
          class="tab-pane fade bg-light"
          id="BinCollection"
          role="tabpanel"
          aria-labelledby="BinCollection-tab"
        >
          <bin-collection-schedule
            @show-tabs="showTabs"
            @never-show-tabs="neverShowTabs"
          />
        </div>
      </div>
    </div>
    <history-details v-if="neverShowTabbable" />
  </div>
</template>
<script>
import HistoryDetails from "./HistoryDetails";
import BinCollectionSchedule from "../../../../common/components/BinCollectionSchedule";
export default {
  components: {
    HistoryDetails,
    BinCollectionSchedule,
  },
  data() {
    return {
      showTabbable: false,
      neverShowTabbable: false,
    };
  },
  mounted() {
    $("#history-and-more-details-nav a").on("click", function (e) {
      e.preventDefault();
      $(this).tab("show");
    });
  },
  methods: {
    showTabs() {
      this.showTabbable = true;
    },
    neverShowTabs() {
      this.neverShowTabbable = true;
    },
  },
};
</script>